import { apiClient } from "../../zodios/client";
import type { UploadType } from "../../zodios/apiDefinitions/uploads";

export async function uploadToS3({ file, uploadType }: { file: File; uploadType: UploadType }): Promise<number> {
  const uploadRes = await apiClient.createUpload({
    upload_type: uploadType,
    file_type: "text/csv",
    name: file.name,
  });

  const id = uploadRes.id;
  const form = await apiClient.getUploadForm({ params: { id } });

  const formData = new FormData();
  Object.entries(form.fields).forEach(([key, value]) => formData.append(key, value));
  formData.append("file", file);

  const uploadResp = await fetch(form.url, {
    method: "POST",
    body: formData,
  });

  if (!uploadResp.ok) {
    const body = await uploadResp.text().catch(() => "");
    throw new Error(`File upload failed (${uploadResp.status})`, { cause: body });
  }

  return id;
}
